(() => {
  const SELECTOR = '[data-calinfi-faqs]';
  const controllers = new WeakMap();

  const setItemOpen = (item, isOpen) => {
    const toggle = item.querySelector('[data-faq-toggle]');
    const panel = item.querySelector('[data-faq-panel]');

    item.classList.toggle('is-open', isOpen);
    toggle?.setAttribute('aria-expanded', String(isOpen));
    panel?.setAttribute('aria-hidden', String(!isOpen));
  };

  const initSection = (section) => {
    if (!section || section.dataset.faqsInitialized === 'true') return;

    const items = Array.from(section.querySelectorAll('[data-faq-item]'));
    if (items.length === 0) return;

    section.dataset.faqsInitialized = 'true';

    const controller = new AbortController();
    const { signal } = controller;
    controllers.set(section, controller);

    const enforceSingleOpen = () => {
      const openItem = items.find((item) => item.classList.contains('is-open')) || items[0];

      items.forEach((item) => setItemOpen(item, item === openItem));
    };

    enforceSingleOpen();

    items.forEach((item) => {
      const toggle = item.querySelector('[data-faq-toggle]');

      toggle?.addEventListener('click', () => {
        if (item.classList.contains('is-open')) {
          return;
        }

        items.forEach((otherItem) => setItemOpen(otherItem, otherItem === item));
      }, { signal });
    });
  };

  document.querySelectorAll(SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches?.(SELECTOR) ? event.target : event.target.querySelector?.(SELECTOR);

    initSection(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches?.(SELECTOR) ? event.target : event.target.querySelector?.(SELECTOR);
    const controller = controllers.get(section);

    controller?.abort();
    controllers.delete(section);

    if (section) delete section.dataset.faqsInitialized;
  });
})();
